export default function Founder() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-28 lg:py-36 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-8 items-center">
        <div className="col-span-12 lg:col-span-5">
          <div className="relative border border-white/10 bg-[#0a0a0a] aspect-[3/4] p-6 flex flex-col justify-between overflow-hidden">
            <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_30%_20%,rgba(220,38,38,0.4),transparent_60%)]" />
            <div className="relative z-10 flex items-center justify-between">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#dc2626]">
                ● FILE · SBK-001
              </div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                CLEARANCE · EXECUTIVE
              </div>
            </div>
            <div className="relative z-10">
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-3">
                Founder & Creator
              </div>
              <div className="font-display uppercase font-black text-4xl md:text-5xl leading-[0.9] tracking-tight">
                Sanjay
                <br />
                Bhandarkar K
              </div>
              <div className="mt-6 space-y-2 font-mono text-xs text-neutral-400">
                <div>
                  <span className="text-neutral-600">EMAIL · </span>
                  <a
                    href="mailto:sanjaykidiyoor@lunipin.com"
                    className="text-white hover:text-[#dc2626]"
                    data-testid="founder-email"
                  >
                    sanjaykidiyoor@lunipin.com
                  </a>
                </div>
                <div>
                  <span className="text-neutral-600">TEL · </span>
                  <a
                    href="tel:+919845739307"
                    className="text-white hover:text-[#dc2626]"
                    data-testid="founder-phone"
                  >
                    +91 98457 39307
                  </a>
                </div>
                <div>
                  <span className="text-neutral-600">WEB · </span>
                  <span className="text-white">www.lunipin.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-7">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#dc2626]" /> 09 · The Architect
          </div>
          <blockquote className="font-display uppercase font-black text-3xl md:text-4xl lg:text-5xl leading-[1.02] tracking-tight">
            <span className="text-[#dc2626]">&ldquo;</span>
            We don&apos;t ask you to change how your people work. We change how your
            organization <span className="text-neutral-500">sees them.</span>
            <span className="text-[#dc2626]">&rdquo;</span>
          </blockquote>
          <div className="mt-8 font-mono text-xs text-neutral-500">
            — Sanjay Bhandarkar K · Founder, Lunipin
          </div>
          <p className="mt-10 text-neutral-400 leading-relaxed max-w-xl">
            Lunipin exists to make organizations see their people differently. The
            simulation is the instrument. The debrief is the outcome. The scaled
            deployment is the change.
          </p>
        </div>
      </div>
    </section>
  );
}
